module.exports = __webpack_public_path__ + "static/kuthpady-55bf86b2a3c28d78645745845bed1914.jpg";